export function ErrorMessage({ id, message }: { id: string; message: string }) {
    return (
        <span id={id} className="ui-element subdued">
            {message}
        </span>
    );
}
